export const page: string[] = [
  'to-do',
  'plan-list',
  'plan-execution',
  'bid-plan-profit',
  'imbalance-prices',
  'site-information',
  'transaction-results',
  'sites-not-eligible-for-bidding',
];
